import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { Row, Column } from 'react-foundation';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';
import simEmpty from '../../static/images/moi-sim-empty.png';
import simEmptyRedLine from '../../static/images/sim-card-empty-red-line.png';
import simCardBallOk from '../../static/images/sim-ok-pallo.png';
import simCardBallError from '../../static/images/sim-error-pallo.png';
import { fadeIn } from 'react-animations';
import { getUIString } from '../../utils/helpers';
import { Icon } from '../../components/Icon';
import { SubscriptionActivationForm } from './SubscriptionActivationForm';
import ActivationSimSettings from './ActivationSimSettings';
import { formatMsisdn } from '../../utils/helpers';
import {Checkbox} from "../../components/Checkbox";

const fadeAnimation = keyframes`${fadeIn}`;

const Centralize = styled.div`
	text-align: center;
`;

const Header = styled.div`
	font-size: 3rem;
`;

const InstructionList = styled.ol`
	padding: 0 0 0 1rem;
	margin-left: 0;
	text-align: left;
	li {
		padding: 2px 5px;
	}
`;

const RedText = styled.p`
	display: inline-block;
	color: red;
`;

const NumberInput = styled.input`
	max-width: 22rem;
	margin: auto;
	margin-bottom: 2rem;
`;

const InfoContainer = styled.div`
	h4 {
		font-size: 1.4rem;
	}

	text-align: center;
	max-width: 24rem;
	margin: auto;
`;

const SimFoundContainer = styled.div`
	text-align: center;
	h4 {
		font-size: 1.6rem;
	}
	p {
		margin: 0;
		margin-bottom: 5px;
	}
	animation: 0.5s ${fadeAnimation};
`;

const FadeContainer = styled.div`
	animation: 0.5s ${fadeAnimation};
`;

const SimCardContainer = styled.div`
  height: 233px;
  width: 368px;
  margin: auto;
  background: url('${(props) => (props.redLine ? simEmptyRedLine : simEmpty)}') no-repeat;
  position: relative;
  text-align: center;

  .button {
    position: relative;
    top: 82px;
  }
`;

const SimCardBallIcon = styled.div`
  position: relative;
  top: 35px;
  left: 2px;
  width: 200px;
  padding-top: 130px;
  margin: auto;
  color: ${(props) => (props.error ? '#666666' : '#93cb12')};
  font-weight: bold;
  font-size: 18px;
  letter-spacing: -0.25px;
  background: url('${(props) => (props.error ? simCardBallError : simCardBallOk)}') center no-repeat;
`;

const SimNumber = styled.div`
	color: #666;
	text-align: center;
	position: relative;
	top: 54px;
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 1px;
	font-family: 'courier new', courier, 'Platform-web', 'Platform', 'Courier';
`;

const ContactInfoContainer = styled.div`
	text-align: center;
	margin: 2em 0 4em 0;
	span {
		font-size: 1.5em;
	}
`;

const SuccesfulActivationNotice = styled.div`
	margin: auto;
	margin-top: 2em;
	width: 20em;
	font-size: 1.6em;
`;

const SimTypeSelector = styled.div`
	margin-top: 2rem;
`;

class ActivateSubscriptionContent extends React.PureComponent {
	// eslint-disable-line

	render() {
		const props = this.props;

		//console.log("props", props)

		return (
			<div>
				<Column className="large-8 large-centered columns" style={{marginTop: "2rem"}}>
					<Centralize>
						{props.accountType === 'business' && <Icon name="medium--sims" />}
						<Header>{getUIString(props.accountType, 'ActivateSubscriptionPage.header')}</Header>
					</Centralize>
				</Column>

				{props.accountType === 'business' && (
					<div>
						{!props.formSubmitted && (
							<div>
								<Row>
									<Column className="large-7 large-centered columns">
										<InstructionList>
											<li>Poimi käteesi käyttämätön sim-kortti.</li>
											<li>Syötä sim-kortin takapuolelta 19-numeron tunnisteesta viisi viimeistä numeroa.</li>
											<li>Kerro kuka käyttää uutta liittymää ja klikkaa ‘Ota liittymä käyttöön’.</li>
										</InstructionList>
										<p>
											Varastossasi on {props.emptySims.toJS().length} {props.emptySims.toJS().length === 1 ? ' tyhjä simmi' : ' tyhjää simmiä'}{' '}
										</p>
										<SimTypeSelector>
											<Checkbox
													messageWidth={'80%'}
													checked={props.isESIM}
													message={
														<>
															Tarvitsen perinteisen SIM-kortin sijaan digitaalisen eSIM-kortin.
														</>
													}
													onChange={() => props.handleSimTypeChange(!props.isESIM)}
											/>
										</SimTypeSelector>
									</Column>
									{!props.isESIM &&
										<Centralize>
											<h4>Syötä simmin tunnisteesta viisi viimeistä numeroa</h4>
											<Column className="large-6 large-centered columns">
												<NumberInput type="text" placeholder="Esim. 01250" onChange={props.handleChange} />
											</Column>
										</Centralize>
									}
								</Row>
							</div>
						)}
						{props.match && !props.formSubmitted && !props.isESIM && (
							<SimFoundContainer>
								<SimCardContainer>
									<SimNumber>12345678901234xxxxx</SimNumber>
									<SimCardBallIcon>
										<div>Uusi simmi löytyi.</div>
									</SimCardBallIcon>
								</SimCardContainer>

								<p>Simmi </p>
								<RedText>{props.foundObject.simId}</RedText>
								<h4>Kuka käyttää tätä liittymää?</h4>
								<SubscriptionActivationForm
									handlerFromParent={props.activateBusinessSubscription}
									freeNumbers={props.freeNumbers}
									transferDates={props.transferDates}
									customer={props.data.toJS()}
								/>
							</SimFoundContainer>
						)}

						{!props.formSubmitted && props.isESIM && (
								<SimFoundContainer>
									<h4>Kuka käyttää tätä liittymää?</h4>
									<SubscriptionActivationForm
											handlerFromParent={props.activateBusinessSubscription}
											freeNumbers={props.freeNumbers}
											transferDates={props.transferDates}
											customer={props.data.toJS()}
									/>
								</SimFoundContainer>
						)}

						{props.emptySims.toJS().length < 1 && (
							<InfoContainer>
								<h4>Yritykselläsi ei näytä olevan tyhjiä simmejä. Ei hätää, tilaa niitä helposti lisää!</h4>
								<Link to="/account/orderMore">
									<Button>Tilaa lisää simmejä varastoon</Button>
								</Link>
							</InfoContainer>
						)}

						{!props.match && !props.formSubmitted && props.value.length > 4 && !props.isESIM && (
							<FadeContainer>
								<SimCardContainer>
									<SimNumber>12345678901234xxxxx</SimNumber>
									<SimCardBallIcon error>
										<div />
									</SimCardBallIcon>
								</SimCardContainer>

								<InfoContainer>
									<h4>Hupsis. Tällä tunnistenumerolla ei löytynyt käyttämätöntä simmiä.</h4>
									<p>Mitä seuraavaksi? Poimi käteesi käyttämätön sim-kortti. Syötä sim-kortin takapuolelta 19-numeron tunnisteesta viisi viimeistä numeroa.</p>
								</InfoContainer>
							</FadeContainer>
						)}

						{!props.match && !props.formSubmitted && (props.value.length <= 4 || props.value === undefined) && !props.isESIM && (
							<FadeContainer>
								<SimCardContainer redLine>
									<SimNumber>12345678901234xxxxx</SimNumber>
								</SimCardContainer>
							</FadeContainer>
						)}

						{(props.match || props.isESIM ) && !props.formSubmitted && !props.isFetching && props.data != null && (
							<FadeContainer>
								<ActivationSimSettings
									sim={null}
									customer={props.data.toJS()}
									onChange={props.handleSettingChange}
									settings={props.settings}
									accountType={props.accountType}
									phoneDirectoryUserInfo={props.phoneDirectoryUserInfo}
									phoneDirectoryOwnerInfo={props.data.toJS().phoneDirectoryOwnerInfo}
									phoneDirectoryOnChange={props.handlePhoneDirectoryChange}
								/>
							</FadeContainer>
						)}
					</div>
				)}

				{props.accountType === 'consumer' && props.location.state && (
					<div>
						<ContactInfoContainer>
							<Icon name="medium--phone" />
							<h4>{props.location.state.name}</h4>
							<span>{formatMsisdn(props.location.state.msisdn)}</span>
						</ContactInfoContainer>
						{!props.formSubmitted && (
							<div>
								<Button onClick={props.activateConsumerSubscription}>Ota liittymä käyttöön</Button>
								<ActivationSimSettings
									{...props}
									sim={null}
									customer={props.data.toJS()}
									onChange={props.handleSettingChange}
									phoneDirectoryOwnerInfo={props.data.toJS().phoneDirectoryOwnerInfo}
									phoneDirectoryOnChange={props.handlePhoneDirectoryChange}
								/>
								<Button onClick={props.activateConsumerSubscription}>Ota liittymä käyttöön</Button>
							</div>
						)}
					</div>
				)}

				{props.newSubFinished && props.formSubmitted && (
					<Column className="large-12 large-centered columns">
						<SuccesfulActivationNotice>
							<Centralize>
								<span>Liittymä otettu onnistuneesti käyttöön!</span>
								<Link to="/account/sims">
									<Button>Siirry Liittymät-sivulle</Button>
								</Link>
							</Centralize>
						</SuccesfulActivationNotice>
					</Column>
				)}
			</div>
		);
	}
}

ActivateSubscriptionContent.propTypes = {
	accountType: PropTypes.string, // eslint-disable-line
	location: PropTypes.object // eslint-disable-line
};

export default ActivateSubscriptionContent;
